export default __webpack_public_path__ + "static/media/icon-Lyra.5cb62325.svg";